<app-str-spinner [message]="spinnerMessage"></app-str-spinner>

<div class=" tds-u-m2">
    <div *ngFor="let item of datesList" class="tds-u-mb1">
        <div class="tds-col-xs-12 tds-u-p2 day-header"  >Job Date: {{ item | date:'fullDate' }}</div>
        <div class="tds-row tds-u-p1 col-header">
            <div class="tds-col-xs-1" style="min-width: 120px;">
                Job type
            </div>

            <div class="tds-col-xs-1" style="min-width: 140px;max-width: 140px;">
                Result
            </div>

            <div class="tds-col-xs-2" style="text-align: right;min-width: 150px;max-width: 150px;">
                Rows affected
            </div>

            <div class="tds-col-xs-7" style="text-align: left;min-width: 300px;">
                Message
            </div>
        </div>

        <div *ngFor="let result of getResultForDate(item)" >

            <div class="tds-row import-row tds-u-pt1 tds-u-pb1" *ngIf="result.jobType == 'IMPORT'">
                <div class="tds-col-xs-1 tds-u-pl2" style="min-width: 120px;">
                    {{result.jobType}}
                </div>

                <div class="tds-col-xs-2" *ngIf="!result.isSuccess" style="min-width: 140px;max-width: 140px;">
                    <div class="pull-left tds-u-pr1" style="color: red;" >
                        <tds-icon slot="icon" size="16px" name="error"></tds-icon>
                    </div>
                    <div class="pull-left">
                        Failed step {{result.jobId}}
                    </div>
                </div>

                <div class="tds-col-xs-2" *ngIf="result.isSuccess" style="min-width: 140px;max-width: 140px;">
                    <div class="pull-left tds-u-pr1" style="color: green;">
                        <tds-icon slot="icon" size="16px" name="tick"></tds-icon>
                    </div>
                    <div class="pull-left">
                        Success step {{result.jobId}}
                    </div>
                </div>

                <div class="tds-col-xs-1" style="text-align: right;min-width: 150px;max-width: 150px;">
                    {{result.rowsAffected}}
                </div>

                <div class="tds-col-xs-7" style="text-align: left;min-width: 300px;">
                    {{result.message}}
                </div>
            </div>


            <div class="tds-row export-row tds-u-pt1 tds-u-pb1" *ngIf="result.jobType == 'EXPORT'">
                <div class="tds-col-xs-1 tds-u-pl2" style="min-width: 120px;">
                    {{result.jobType}}
                </div>

                <div class="tds-col-xs-2" *ngIf="!result.isSuccess"  style="min-width: 140px;max-width: 140px;">
                    <div class="pull-left tds-u-pr1" style="color: red;" >
                        <tds-icon slot="icon" size="16px" name="error"></tds-icon>
                    </div>
                    <div class="pull-left">
                        Failed step {{result.jobId}}
                    </div>
                </div>

                <div class="tds-col-xs-2 tds-u-pr1" *ngIf="result.isSuccess" style="min-width: 140px;max-width: 140px;">
                    <div class="pull-left" style="color: green;">
                        <tds-icon slot="icon" size="16px" name="tick"></tds-icon>
                    </div>
                    <div class="pull-left">
                        Success step {{result.jobId}}
                    </div>
                </div>


                <div class="tds-col-xs-1" style="text-align: right;min-width: 150px;max-width: 150px;">
                    {{result.rowsAffected}}
                </div>

                <div class="tds-col-xs-7" style="text-align: left;min-width: 300px;">
                    {{result.message}}
                </div>
            </div>

        </div>
    </div>
</div>
